import { api } from "./client";
import type { LoginRequest, LoginResponse, UserOut } from "@/types/api";

export async function login(payload: LoginRequest): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>("/auth/login", payload);
  return data;
}

export async function fetchMe(): Promise<UserOut> {
  const { data } = await api.get<UserOut>("/me");
  return data;
}
